import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { 
  Container,
  TextField,
  Typography,
} from '@mui/material';
import {
  LoginContainer,
  LoginPaper,
  FormContainer,
  StyledLink,
  BackgroundContainer,
  StyledAlert,
  LoginHeader,
  LoginButton
} from './LoginPage.styles';
import { Logo } from '../../components/MenuSideBar/MenuSideBar.styles';
import { API_BASE_URL } from '../../api/api';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import Divider from '@mui/material/Divider';
import { ENVIRONMENT } from '../../utils/config'


export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const { login, passwordReset } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isOnDevelopment = ENVIRONMENT === 'development'

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const success = await login(email, password);
    if (success) {
      const from = location.state?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    } else {
      setError('Failed to log in');
    }
  };

  const handlePasswordReset = async () => {
    const success = await passwordReset(email);

    if (success) {
      setConfirmation('Password reset email sent.');
    } else {
      setError('Failed to send password reset request.');
    }
  };

  const handleMicrosoftLogin = async () => {
    try {
      window.location.href = `${API_BASE_URL}/users/auth/azure_oauth2`;
    } catch {
      setError('Failed to initialize Microsoft login');
    }
  };

  return (
    <BackgroundContainer>
      <Container component="main" maxWidth="xs">
        <LoginContainer>
          <LoginPaper elevation={3}>
            <Logo data-testid="sidebar-logo" isCollapsed={false}>
              <img src="/Icons/Jigsaw-Logo.png" alt="Jigsaw Logo" />
            </Logo>
            <LoginHeader component="h1" variant="h5">
              Login
            </LoginHeader>

            {error && <StyledAlert severity="error" data-testid="error-message">{error}</StyledAlert>}
            {confirmation && <StyledAlert severity="success" data-testid="confirmation-message">{confirmation}</StyledAlert>}

            <LoginButton
              fullWidth
              variant="contained"
              startIcon={<MicrosoftIcon />}
              onClick={handleMicrosoftLogin}
              sx={{ mb: 2 }}
            >
              Sign in with Microsoft
            </LoginButton>

            {isOnDevelopment && (
              <>
                <Divider flexItem />

                <FormContainer onSubmit={handleSubmit}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="username"
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    data-testid="password"
                  />
                  <LoginButton
                    type="submit"
                    variant="outlined"
                    data-testid="submit"
                  >
                    Login
                  </LoginButton>


                  <Typography variant="body2" align="center">
                    <StyledLink>
                      <Link
                        data-testid="forgot-password"
                        onClick={handlePasswordReset}
                        style={{ cursor: 'pointer' }}
                      >
                        Forgot Password
                      </Link>
                    </StyledLink>
                  </Typography>
                </FormContainer>
              </>
            )}
          </LoginPaper>
        </LoginContainer>
      </Container>
    </BackgroundContainer>
  );
};